import React from "react";
import { FormattedMessage } from "react-intl";

export default [
    {
        name: "organizationName",
        label: <FormattedMessage id="order.client-name" />,
        type: "string",
    },
    {
        name: "organizationId",
        label: <FormattedMessage id="order.client-id" />,
        type: "string",
    },
    {
        name: "tripIds",
        label: <FormattedMessage id="order.trips-list" />,
        type: "list",
        url: "/trips",
        entityName: "trips",
        isMultiple: true,
        filterValue: "id",
        hasPreviewPage: true,
    },
    {
        name: "supplierId",
        label: <FormattedMessage id="order.supplier" />,
        type: "relation",
        collection: "suppliers",
        entityName: "supplier",
        fields: ["name"],
    },
    {
        name: "status",
        label: <FormattedMessage id="order.status" />,
        type: "string",
    },
    {
        name: "requestedAt",
        label: <FormattedMessage id="order.request-date" />,
        type: "date",
    },
    {
        name: "createdAt",
        label: <FormattedMessage id="order.created-at" />,
        type: "date",
    },
    {
        name: "clientNotes",
        label: <FormattedMessage id="order.client-note" />,
        type: "string",
    },
    {
        name: "contractType",
        label: <FormattedMessage id="order.contract-type" />,
        type: "string",
    },
    {
        name: "projectId",
        label: <FormattedMessage id="order.project" />,
        type: "list",
        url: "/projects",
        filterValue: "name",
        entityName: "project",
        formatLabels: true,
        include: true,
    },
];
